export default "__VITE_ASSET__UWYn1Unq__"